import { Col, Form, InputNumber, Row } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import { inputNumberFormatter } from '../../utils/buybackHelpers'

const gutter: Gutter | [Gutter, Gutter] = [16, 16]

export const BuybackFormIncomeFragment: FunctionComponent = () => {
  return (
    <Row gutter={gutter} className="mt-4">
      <Col xs={24} md={13}>
        <Form.Item
          name={FIELD.HouseholdIncome}
          label="Celkový příjem domácnosti"
        >
          <InputNumber
            min={0}
            step={1000}
            className="w-full"
            formatter={inputNumberFormatter}
            addonAfter="Kč"
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={11}>
        <Form.Item
          name={FIELD.HouseholdMembers}
          label="Počet členů v domácnosti"
        >
          <InputNumber min={0} step={1} className="w-full" addonAfter="os." />
        </Form.Item>
      </Col>
    </Row>
  )
}
